/* DIVA Shoes Elhenawy — interaction layer © 2026 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var preloader = document.querySelector('[data-diva-preloader]');

  function dismissPreloader() {
    if (!preloader) return;
    preloader.classList.add('is-hidden');
    window.setTimeout(function () { if (preloader.parentNode) preloader.parentNode.removeChild(preloader); }, 650);
  }

  if (preloader) {
    var hasVisited = false;
    try { hasVisited = sessionStorage.getItem('diva-preloader-seen') === '1'; } catch (e) {}
    if (hasVisited || reduceMotion || (window.Shopify && Shopify.designMode)) {
      dismissPreloader();
    } else {
      try { sessionStorage.setItem('diva-preloader-seen', '1'); } catch (e) {}
      window.addEventListener('load', dismissPreloader, { once: true });
      window.setTimeout(dismissPreloader, 2200);
    }
  }

  function initReveal(root) {
    var scope = root || document;
    if (window.divaSettings && window.divaSettings.animations === false) return;
    var items = scope.querySelectorAll('[data-diva-reveal]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, current) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        current.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index * 45, 240) + 'ms';
      observer.observe(item);
    });
  }

  function markRevealTargets(root) {
    if (window.divaSettings && window.divaSettings.animations === false) return;
    var scope = root || document;
    scope.querySelectorAll('.shopify-section:not(.header-section):not(.footer-section), .product-card').forEach(function (item) {
      if (!item.hasAttribute('data-diva-reveal')) item.setAttribute('data-diva-reveal', 'up');
    });
  }

  function initHeaderState() {
    var header = document.querySelector('.header');
    if (!header || !header.classList.contains('header-sticky')) return;
    var update = function () { document.documentElement.classList.toggle('diva-scrolled', window.scrollY > 24); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  markRevealTargets(document);
  initReveal(document);
  initHeaderState();
  document.addEventListener('shopify:section:load', function (event) { markRevealTargets(event.target); initReveal(event.target); initHeaderState(); });
  document.addEventListener('product-card-updated', function () { markRevealTargets(document); initReveal(document); });
}());
